import Logo from "../../../../../../assets/images/hajex_logo.png";
import Tooltip from "../../../../../../Components/Tooltip/Tooltip";

import { MdDownload } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import { useTranslation } from "react-i18next";

export default function Header({
  order,
  handleClose,
  downloadPdf,
  type = "show",
}) {
  const { t } = useTranslation(["warehouse", "common"]);
  const buttonConfig = [
    {
      id: "Order",
      text: t("orderDetails.buttonOrder"),
      icon: MdDownload,
      onClick: () => downloadPdf(order?.order_id, false),
      disabled: false,
      tooltip: t("orderDetails.downloadOrderPdf"),
    },
    {
      id: "Pack",
      text: t("orderDetails.buttonPack"),
      icon: MdDownload,
      onClick: () => downloadPdf(order?.order_id, true),
      disabled: false,
      tooltip: t("orderDetails.downloadPackingListPdf"),
    },
    {
      id: "Label",
      text: t("orderDetails.buttonLabel"),
      icon: MdDownload,
      onClick: () =>
        order?.manual_shipment?.shipping_labels?.length > 0
          ? printMultipleFiles(
              order?.manual_shipment?.shipping_labels,
              order?.manual_shipment?.shipment_tracking_id,
            )
          : printLabel(order?.shipment, "Label"),
      disabled:
        (order?.shipment?.single_shipping_labels?.file &&
          order?.shipment?.shipment_status?.toLowerCase() !== "cancelled") ||
        order?.manual_shipment?.shipping_labels?.length > 0
          ? false
          : true,
      tooltip: t("orderDetails.downloadShippingLabel"),
    },
    {
      id: "Decl",
      text: t("orderDetails.buttonDecl"),
      icon: MdDownload,
      onClick: () =>
        order?.manual_shipment?.shipping_declarations?.length > 0
          ? printMultipleFiles(
              order?.manual_shipment?.shipping_declarations,
              order?.manual_shipment?.shipment_tracking_id,
            )
          : printLabel(order?.shipment, "Declaration"),
      disabled:
        (order?.shipment?.single_shipping_invoice?.file &&
          order?.shipment?.shipment_status?.toLowerCase() !== "cancelled") ||
        order?.manual_shipment?.shipping_declarations?.length > 0
          ? false
          : true,
      tooltip: t("orderDetails.downloadShipmentDeclaration"),
    },
    {
      id: "Close",
      text: t("common:actions.close"),
      icon: RxCross2,
      onClick: handleClose,
      disabled: false,
      tooltip: t("orderDetails.closeTheOrder"),
    },
  ];

  const printLabel = async (shipment, type) => {
    try {
      let url = "";
      if (type === "Label") {
        url = shipment?.single_shipping_labels.file;
      } else {
        url = shipment?.single_shipping_invoice.file;
      }
      // setActionLoader(row.id);
      fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
        },
      })
        .then((url) => url.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${
              shipment?.tattension +
              " " +
              shipment?.shipment_tracking_id +
              " " +
              type
            }.pdf`,
          );
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          // setActionLoader(false);
        });
    } catch (error) {
      // setSnack((snack) => {
      //   setActionLoader(false);
      //   return {
      //     ...snack,
      //     open: true,
      //     text: "Something went wrong try again later",
      //     severity: "error",
      //   };
      // });
    }
  };

  const printMultipleFiles = async (data, shipment) => {
    try {
      data?.forEach(async (label, index) => {
        const response = await fetch(label.file, {
          method: "GET",
          headers: {
            "Content-Type": "application/pdf",
          },
        });
        const blob = await response.blob();
        const url = window.URL.createObjectURL(new Blob([blob]));

        // Extract file extension from the URL
        const fileExtension = label.file.split(".").pop();

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${shipment}_${label.type}_${index + 1}.${fileExtension}`,
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    } catch (error) {
      console.error("Error downloading labels:", error);
      // Handle error here
    }
  };

  // Phones: 40px buttons with the icon beside the label. From md up: the
  // square buttons with the label under the icon. The padding is px-[12px],
  // not px-3: Bootstrap's own .px-3 (1rem !important) would win over md:px-0
  // and squeeze the label into a column of single letters.
  const renderButton = ({ id, text, icon: Icon, onClick, disabled, tooltip }) => (
    <Tooltip key={id} title={disabled ? t("orderDetails.notAvailable") : tooltip}>
      <button
        onClick={onClick}
        disabled={disabled}
        className={`
        group
        flex items-center justify-center gap-1.5
        h-10 px-[12px] ${id === "Close" ? "" : "flex-1"}
        md:flex-[0_1_auto] md:flex-col md:gap-0 md:w-10 md:px-0
        rounded-md border border-brand-light
        text-[12px] md:text-[8px]
        leading-none
        transition-all duration-200
        ${
          disabled
            ? "bg-ui-border text-ui-text-subtle cursor-not-allowed"
            : "bg-ui-surface cursor-pointer hover:!bg-brand hover:text-white"
        }
      `}
      >
        {/* ICON (NO TEXT INHERIT ISSUES) */}
        <Icon
          size={14}
          className={`transition-colors duration-200 ${
            disabled
              ? "text-ui-text-subtle"
              : "text-ui-text group-hover:text-white"
          }`}
        />

        {/* LABEL */}
        <span
          className={`md:mt-[1px] transition-colors duration-200 ${
            disabled
              ? "text-ui-text-subtle"
              : "text-ui-text group-hover:text-white"
          }`}
        >
          {text}
        </span>
      </button>
    </Tooltip>
  );

  return (
    <>
      {/* HEADER (screen only) */}
      {/* Phones: logo, title and Close on top, the downloads on a row of
          their own. From md up: logo | title | buttons. */}
      {type !== "print" && (
        <div className="bg-ui-surface border-b border-ui-border p-2">
          <div className="flex flex-wrap items-center gap-2 md:grid md:grid-cols-3">
            {/* LEFT - LOGO */}
            <div className="flex shrink-0 items-center justify-start">
              <img
                src={Logo}
                alt={t("orderDetails.logo")}
                className="h-5 md:h-6 w-auto object-contain"
              />
            </div>

            {/* CENTER - TITLE */}
            <div className="flex min-w-0 flex-1 justify-start md:justify-center">
              <h2 className="mb-[0px] md:mb-2 text-[13px] md:text-base font-semibold text-ui-text-muted text-left md:text-center leading-tight">
                {t("orderDetails.orderTitle", { id: order?.order_id ?? "" })}
              </h2>
            </div>

            {/* RIGHT - BUTTONS (no box of its own on phones) */}
            <div className="contents md:flex md:justify-end md:flex-wrap md:gap-2">
              <div className="order-last flex basis-full gap-2 md:contents">
                {buttonConfig
                  .filter(({ id }) => id !== "Close")
                  .map(renderButton)}
              </div>
              {buttonConfig
                .filter(({ id }) => id === "Close")
                .map(renderButton)}
            </div>
          </div>
        </div>
      )}

      {/* PRINT MODE */}
      {type === "print" && (
        <div className="flex justify-start mb-4">
          <img src={Logo} alt={t("orderDetails.logo")} className="h-5 w-auto object-contain" />
        </div>
      )}
    </>
  );
}
